export const TOOL_POLICY_OPTIONS = [
  { value: 'always_allow', label: 'Always allow' },
  { value: 'need_approval', label: 'Need approval' },
  { value: 'blocked', label: 'Blocked' },
];

export function inferMcpToolKind(toolName) {
  const name = (toolName || '').toLowerCase();
  const writeVerbs = [
    'create', 'update', 'delete', 'write', 'set', 'add', 'post', 'put', 'patch',
    'insert', 'remove', 'send', 'publish', 'append',
  ];
  if (writeVerbs.some((verb) => name.includes(verb))) return 'write';
  return 'read';
}

export function toolKindForPolicy(tool, rowType = 'http') {
  if (rowType === 'http') return tool.kind || 'read';
  return inferMcpToolKind(tool.name);
}

export function defaultToolPolicy(kind) {
  return kind === 'write' ? 'need_approval' : 'always_allow';
}

export function getEffectiveToolPolicy(toolPolicies, toolName, kind = 'read') {
  const policies = toolPolicies && typeof toolPolicies === 'object' ? toolPolicies : {};
  const stored = policies[toolName];
  if (TOOL_POLICY_OPTIONS.some((o) => o.value === stored)) return stored;
  return defaultToolPolicy(kind);
}

export function getAssistantIdsInScope(scopeTab, { userAssistants = [], platformAssistants = [], isAdmin = false }) {
  let assistants = userAssistants;
  if (scopeTab === 'platform' && isAdmin) {
    assistants = platformAssistants;
  } else if (scopeTab === 'personal') {
    assistants = userAssistants.filter((a) => !a.group_id);
  } else if (scopeTab === 'group') {
    assistants = userAssistants.filter((a) => a.group_id);
  }
  return new Set(assistants.map((a) => a.id));
}

export function filterToolRowsByScope(rows, scopeTab, scopeContext) {
  const { isAdmin, assistantsLoaded = true } = scopeContext;
  if (scopeTab === 'platform' && !isAdmin) return [];

  // Don't hide tools while assistants are still loading — scope needs assistant ids.
  if (!assistantsLoaded) {
    return rows.filter((row) => {
      if (row.rowType === 'native') return scopeTab === 'platform' && isAdmin;
      return true;
    });
  }

  const idsInScope = getAssistantIdsInScope(scopeTab, scopeContext);

  return rows.filter((row) => {
    if (row.rowType === 'native') {
      return scopeTab === 'platform' && isAdmin;
    }
    const linked = row.linkedAssistantIds || [];
    if (linked.length === 0) {
      return scopeTab === 'personal';
    }
    return linked.some((id) => idsInScope.has(id));
  });
}

export function countToolsForScope(rows, scopeTab, scopeContext) {
  return filterToolRowsByScope(rows, scopeTab, scopeContext).length;
}
